import React from 'react'
import {
  InteriorQuality as InteriorQualityType,
  RealEstateCategory,
  Salutation,
  SegmentationType,
  TransactionType,
} from '../../../../../@types/types'
import { Flow, FlowName, FlowScreenElement } from '../../../../../@types/flow-types'
import {
  SCREEN_ADDRESS,
  SCREEN_BASIC_INFO,
  SCREEN_DESCRIPTION,
  SCREEN_MULTIMEDIA,
  SCREENS,
} from '../../../../../services/domain/wizardScreens'
import Address from '../../../../../components/pages/insertionPage/screens/address/Address'
import { AGENT_WAITING_LIST_APARTMENT_RENT_FLOW_PATH } from '../../../../../services/routes/routes'
import Description from '../../../../../components/pages/insertionPage/screens/description/Description'
import Multimedia from '../../../../../components/pages/insertionPage/screens/multimediaNew/Multimedia'

import { agentWaitingListApartmentRentSchema } from './agentWaitingListApartmentRentSchema'
import { priceToApiMonthlyRentWithManualTotalRent } from '../../../../../api/realEstate/converters/toApi/estate/price/priceToApi'
import { MultimediaUploaderType } from '../../../../../@types/multimedia-types'
import BasicInfo from '../../../../../components/pages/insertionPage/screens/basicInfo/BasicInfo'
import {
  livingSpaceField,
  priceField,
  roomField,
} from '../../../../../components/pages/insertionPage/screens/basicInfo/wrappers/basicInfoFieldsWrapper'
import { PriceFieldType } from '../../../../../components/pages/insertionPage/screens/basicInfo/fields/priceField/PriceField'

const agentWaitingListApartmentRentFlowScreens: FlowScreenElement[] = [
  {
    screen: SCREENS[SCREEN_ADDRESS],
    element: (props) => <Address {...props} isPriceOverviewLinkDisplayed={false} />,
  },
  {
    screen: SCREENS[SCREEN_BASIC_INFO],
    element: (props) => (
      <BasicInfo
        {...props}
        properties={[
          livingSpaceField(),
          roomField(),
          priceField(PriceFieldType.COLD_RENT, 'one-half palm-padding-left-m lap-padding-right-m desk-padding-right-m'),
        ]}
      />
    ),
  },
  {
    screen: SCREENS[SCREEN_DESCRIPTION],
    element: (props) => (
      <Description
        {...props}
        hasFurnishingNote={false}
        hasLocationNote={false}
        hasOtherNote={false}
        hasNoDescriptionNote={true}
      />
    ),
  },
  {
    screen: SCREENS[SCREEN_MULTIMEDIA],
    element: (props) => (
      <Multimedia
        {...props}
        doCloseMultimediaStatusMessage={props.doCloseMultimediaStatusMessage!}
        allowedTypesToDisplay={[MultimediaUploaderType.PICTURE, MultimediaUploaderType.VIDEO]}
      />
    ),
  },
]

export const agentWaitingListApartmentRentFlow: Flow = {
  flowInformation: {
    owner: 'wizard.navigation.header.agent',
    estateType: 'wizard.navigation.header.apartment',
    offerType: 'wizard.navigation.header.waitingList',
    path: AGENT_WAITING_LIST_APARTMENT_RENT_FLOW_PATH,
    name: FlowName.AGENT_WAITING_LIST_APARTMENT_RENT,
    validationSchema: agentWaitingListApartmentRentSchema,
    options: {
      hasTextSuggestions: false,
      isWaitingListFlow: true,
      customPageHeader: {
        titleKey: 'header.title.waitingList',
        descriptionKey: 'header.description.waitingList',
      },
    },
    metaData: {
      category: RealEstateCategory.APARTMENT,
      segmentation: SegmentationType.AGENT,
      transaction: TransactionType.RENT,
    },
    priceToApiMapper: priceToApiMonthlyRentWithManualTotalRent,
  },
  defaultStateValues: {
    heatingCostsOption: true,
    unknownConstructionYear: false,
    hideStreetAndStreetNumber: false,
    estateFeatures: {},
    interiorQuality: InteriorQualityType.NO_INFORMATION,
    salutation: Salutation.NO_SALUTATION,
  },
  flowScreens: agentWaitingListApartmentRentFlowScreens,
}
